var render, staticRenderFns
import script from "./WxSelect.vue?vue&type=script&lang=js"
export * from "./WxSelect.vue?vue&type=script&lang=js"
import style0 from "./WxSelect.vue?vue&type=style&index=0&id=3ed084fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed084fd",
  null
  
)

export default component.exports